<template>
  <div
    @click="focusOutFilter"
    class="column padding-bottom-0 custom-dropdown custom-dropdown--small padding-top-0 padding-right-0"
  >
    <div class="padding-right-0">
      <div :class="[{'is-active': isDropdownActive}, 'dropdown']" @click="focusOutFilter">
        <div class="dropdown-trigger">
          <button aria-controls="dropdown-menu" aria-haspopup="true" class="button button-dropdown"
                  :disabled="disabled">
            <span class="is-size-7 has-text-weight-bold" v-text="label"></span>
          </button>
        </div>
        <div class="dropdown-menu padding-top-0 padding-bottom-0" role="menu">
          <div class="dropdown-content is-marginless is-paddingless">
            <div :key="index" v-for="(option, index) in options">
              <div class="columns is-mobile is-paddingless is-marginless border-bottom-dbdbdb dropdown-option">
                <div class="column is-12 is-paddingless">
                  <div class="datepicker-trigger">
                    <label
                      class="radio label-filters has-text-weight-bold"
                      v-if="option.type === 'group'"
                    >
                      {{ option.label }}
                    </label>

                    <colored-checkbox
                      v-else-if="option.type === 'checkbox'"
                      @cb-toggle="checkboxToggle($event, option)"
                      :cbVal="option.value"
                      :is-checked="option.checked"
                      v-bind="option.props"
                    >
                      <span class="checkbox-label" v-if="option.component">
                        <template v-for="label in option.label">
                          <span v-html="label" v-if="typeof label !== 'object'"></span>
                          <component :is="label.component" v-bind="label.props" v-else/>
                        </template>
                      </span>
                      <span class="checkbox-label" v-else v-html="option.label"></span>
                    </colored-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent,no-new,no-undef,valid-jsdoc */
import ColoredCheckbox from './ColoredCheckbox'
import Rating from './Rating'

export default {
  name: 'CustomDropdownForm',
  components: {
    ColoredCheckbox,
    Rating
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    group: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isDropdownActive: false
    }
  },
  methods: {
    /**
     * Function to fire event when focus on filter
     *
     * @param {event} event to handle filter on focus
     * @returns {void}
     */
    focusOutFilter (event) {
      event.stopPropagation()
      this.isDropdownActive = !this.isDropdownActive
    },
    checkboxToggle (isChecked, option) {
      window.events.$emit('custom-dd-form-changed', {
        group: this.group,
        data: option,
        isChecked
      })
    }
  }
}
</script>

<style scoped>
label {
  color: #8a8c91;
  padding: 0.9em;
}

.dropdown-trigger {
  text-align: left;
  width: 100%;
}

.dropdown {
  width: 100%;
}

.label-filters {
  color: #58595b;
  font-size: 0.8rem !important;
  padding: 0px !important;
}

.dropdown-menu {
  border-top: 3px solid #30aae1;
  width: 100%;
  min-width: 100%;
}

.dropdown-content {
  border-radius: 0;
  box-shadow: none !important;
}

.border-bottom-dbdbdb {
  border: 1px solid rgba(88, 89, 91, 0.12);
  border-top: none;
  padding-bottom: 16px !important;
}

.column label.radio {
  display: block;
  padding-left: 0 !important;
  margin-left: 16px;
}

.radio input {
  opacity: 0 !important;
}

.button.button-dropdown {
  padding-left: 12px !important;
}

.button.button-dropdown span {
  min-height: 17px;
}

.column label {
  margin-left: 0px !important;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #bcbec0;
  border-radius: 10px;
}

.checkbox-label {
  margin-left: 9px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomDropdownForm.vue